import useSWR, { SWRResponse, SWRConfiguration } from 'swr';
import { AxiosError } from 'axios';
import { getMarketingDesign } from '../../../providers/api/marketing/marketingProvider';
import { Design } from '../../../providers/api/dtos';

export const MARKETING_DESIGN_BY_ID_RID = '/marketing/design/:id';

export default function useMarketingDesign(id?: string, options?: SWRConfiguration<Design>): SWRResponse<Design, AxiosError> {
  return useSWR(
    id ? [MARKETING_DESIGN_BY_ID_RID, id] : null,
    () => getMarketingDesign(id!),
    options,
  );
}
